import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import LOGO from "../data/EPLOGO.png";

const NAV_LINKS = [
  { label: "Home",     to: "/" },
  { label: "About",    to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Services", to: "/services" },
  { label: "Contact",  to: "/contact" },
];

function SiteHeader() {
  const location  = useLocation();
  const [scrolled,    setScrolled]    = useState(false);
  const [menuOpen,    setMenuOpen]    = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 60);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close drawer on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Lock body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  function isActive(to) {
    return location.pathname === to;
  }

  return (
    <>
      <header className={`site-header${scrolled ? " scrolled" : ""}`}>
        <div className="container site-header-inner">

          {/* Logo */}
          <Link to="/" className="nav-logo" aria-label="Etiquette Pharmaceuticals — Home">
            <img src={LOGO} alt="" className="nav-logo-img" />
            <span className="nav-logo-text">
              <span className="nav-logo-name">Etiquette Pharmaceuticals</span>
              <span className="nav-logo-sub">Wholesale Distribution</span>
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="nav-links" aria-label="Primary navigation">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`nav-link${isActive(link.to) ? " active" : ""}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="nav-cta">
            <Link to="/contact" className="btn btn-primary">
              Request a Quote
            </Link>
          </div>

          {/* Hamburger */}
          <button
            className={`hamburger${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>

        </div>
      </header>

      {/* Mobile drawer */}
      <nav
        className={`mobile-drawer${menuOpen ? " open" : ""}`}
        aria-label="Mobile navigation"
      >
        {NAV_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`mobile-nav-link${isActive(link.to) ? " active" : ""}`}
          >
            {link.label}
          </Link>
        ))}
        <Link to="/contact" className="btn btn-primary">
          Request a Quote
        </Link>
      </nav>
    </>
  );
}

export default SiteHeader;
